var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChestTurnover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8615 25.9775V41.7647C34.8615 42.5567 34.2231 43.1999 33.4263 43.1999H14.5719C13.7799 43.1999 13.1367 42.5615 13.1367 41.7647V25.9775C13.2423 26.0015 13.3479 26.0159 13.4583 26.0159H34.5399C34.6503 26.0159 34.7607 26.0015 34.8615 25.9775Z",
    fill: "#3C4B59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9754 12.5856V24.5808C35.9754 25.368 35.3322 26.016 34.5402 26.016H13.4586C12.6666 26.016 12.0234 25.3728 12.0234 24.5808V12.5856C12.0234 11.7936 12.6618 11.1504 13.4586 11.1504H34.5402C35.3274 11.1552 35.9754 11.7936 35.9754 12.5856Z",
    fill: "#626C78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9395 16.1855H34.0659V24.1055H13.9395V16.1855Z",
    fill: "#57B5E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 12.6572H31.5983V14.678H16.4062V12.6572Z",
    fill: "#3C4B59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5078 14.6782V4.7998L29.9174 5.3278L29.3222 4.7998L28.7318 5.3278L28.1414 4.7998L27.551 5.3278L26.9558 4.7998L26.3654 5.3278L25.775 4.7998L25.1846 5.3278L24.5894 4.7998L23.999 5.3278L23.4086 4.7998L22.8134 5.3278L22.223 4.7998L21.6326 5.3278L21.0422 4.7998L20.447 5.3278L19.8566 4.7998L19.2662 5.3278L18.6758 4.7998L18.0806 5.3278L17.4902 4.7998V14.6782H30.5078Z",
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5703 28.6699H18.4263V31.5259H15.5703V28.6699Z",
    fill: "#EE4659"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2363 28.6699H23.0923V31.5259H20.2363V28.6699Z",
    fill: "#61BE7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9062 28.6699H27.7623V31.5259H24.9062V28.6699Z",
    fill: "#F7C680"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5723 28.6699H32.4283V31.5259H29.5723V28.6699Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5703 33.1631H18.4263V36.0191H15.5703V33.1631Z",
    fill: "#E5E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2363 33.1631H23.0923V36.0191H20.2363V33.1631Z",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9062 33.1631H27.7623V36.0191H24.9062V33.1631Z",
    fill: "#E5E5E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5723 33.1631H32.4283V36.0191H29.5723V33.1631Z",
    fill: "#E5E5E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5703 37.6514H18.4263V40.5074H15.5703V37.6514Z",
    fill: "#E5E5E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2363 37.6514H23.0923V40.5074H20.2363V37.6514Z",
    fill: "#E5E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9062 37.6514H27.7623V40.5074H24.9062V37.6514Z",
    fill: "#E5E5E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5723 37.6514H32.4283V40.5074H29.5723V37.6514Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestTurnover);
export default __webpack_public_path__ + "static/media/chest_turnover.fedbea8c95fe6561847e012ed2ead593.svg";
export { ForwardRef as ReactComponent };